'use client';

import FreestarAdSlot from '@freestar/pubfig-adslot-react-component';
import { useEffect, useMemo } from 'react';
import { useAdContext } from '@/app_lib/providers/AdProvider';

export const FreeStarScript = () => {
  const { pageAdConfig, arcSpanPageConfig } = useAdContext();
  const arcSpanConfig = useMemo(
    () => ({
      ...pageAdConfig,
      ...arcSpanPageConfig,
    }),
    [pageAdConfig, arcSpanPageConfig],
  );

  useEffect(() => {
    for (const [key, value] of Object.entries(arcSpanConfig)) {
      if (value) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        FreestarAdSlot.setPageTargeting(key, value);
      }
    }
  }, [arcSpanConfig]);

  return <></>;
};
